import VerticalLine_VerticalNotchDashedLineComponent from '@wix/thunderbolt-elements/src/components/VerticalLine/viewer/skinComps/BaseVerticalLine/VerticalNotchDashedLine.skin';
import VerticalLine_VerticalNotchDashedLineController from '@wix/thunderbolt-elements/src/components/VerticalLine/viewer/VerticalLine.controller';


const VerticalLine_VerticalNotchDashedLine = {
  component: VerticalLine_VerticalNotchDashedLineComponent,
  controller: VerticalLine_VerticalNotchDashedLineController
};


export const components = {
  ['VerticalLine_VerticalNotchDashedLine']: VerticalLine_VerticalNotchDashedLine
};

